import { createFileRoute } from '@tanstack/react-router';
import { ConfigureCustomModelResult } from 'src/features/agents/new/ConfigureCustomModelStep';
import { z } from 'zod';

import { ChooseIntegrationResult, ChooseTemplateResult, New } from '@/features/agents';

const TEMPLATE_KEY = 'template';

export type NewAgent = ChooseTemplateResult & ChooseIntegrationResult & ConfigureCustomModelResult;

const newAgentSchema = z.object({
  [TEMPLATE_KEY]: z.optional(z.string()),
});

export const Route = createFileRoute('/_auth/_org/agents/new')({
  validateSearch: newAgentSchema,
  component: New,
});
